export const syncChartOfAccountsApi = () =>{
   return `/integrations/quickbooks/chart-of-accounts/sync/`;
}

export const syncProductServiceApi = () => {
   return `/integrations/quickbooks/products-services/sync/`;
}

export const syncInvoicesApi = () => {
   return `/integrations/quickbooks/invoices/sync/`;
}

export const pullInvoicePaymentsApi = () => {
   return `/integrations/quickbooks/invoices/pull-payments/`;
}

export const getQbStatusApi = () => {
   return `/integrations/quickbooks/status/`;
}